//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get basket
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function get(offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.BasketGetResponseDto> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket?";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.BasketGetResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initBasketGetResponseDto(resultData200);
        return Promise.resolve<Types.BasketGetResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.BasketGetResponseDto>(null as any);
}

/**
 * Send warranty request
 * @param additionalEmail (optional) Additional email-adress (mailzusatz)
 * @param reference (optional) Reference (kundenref)
 */
export function sendWarrantyRequest(additionalEmail?: string | null | undefined, reference?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket?";
    if (additionalEmail !== undefined && additionalEmail !== null)
        url_ += "AdditionalEmail=" + encodeURIComponent("" + additionalEmail) + "&";
    if (reference !== undefined && reference !== null)
        url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendWarrantyRequest,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendWarrantyRequest?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendWarrantyRequest(_response);
    });
}

function processSendWarrantyRequest(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * Get certain order
 * @param itemNumber (optional) Number of the certain order item (epos)
 * @param language (optional) 
 */
export function getCertainOrder(itemNumber?: string | undefined, language?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.BasketCertainOrderResponseDto> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket/order?";
    if (itemNumber === null)
        throw new Error("The parameter 'itemNumber' cannot be null.");
    else if (itemNumber !== undefined)
        url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCertainOrder,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCertainOrder?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCertainOrder(_response);
    });
}

function processGetCertainOrder(response: AxiosResponse): Promise<Types.BasketCertainOrderResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initBasketCertainOrderResponseDto(resultData200);
        return Promise.resolve<Types.BasketCertainOrderResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.BasketCertainOrderResponseDto>(null as any);
}

/**
 * Edit order
 */
export function patchOrder(request: Types.BasketPatchOrderDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket/order";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeBasketPatchOrderDto(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchOrder,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchOrder?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchOrder(_response);
    });
}

function processPatchOrder(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Change order's alive status (stored status)
 */
export function patchOrderStatus(request: Types.BasketPatchOrderStatusDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket/order/status";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeBasketPatchOrderStatusDto(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchOrderStatus,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchOrderStatus?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchOrderStatus(_response);
    });
}

function processPatchOrderStatus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Clear all orders from the basket
 */
export function clearBasket(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket/clear";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigClearBasket,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigClearBasket?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processClearBasket(_response);
    });
}

function processClearBasket(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get last added device with same service product id
 * @param serviceProduct (optional) Service product (serviceprodukt)
 */
export function searchLastAddedDevice(serviceProduct?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SameDeviceResponseDto> {
    let url_ = getBaseUrl() + "/api/warranty-request/basket/same-device?";
    if (serviceProduct === null)
        throw new Error("The parameter 'serviceProduct' cannot be null.");
    else if (serviceProduct !== undefined)
        url_ += "ServiceProduct=" + encodeURIComponent("" + serviceProduct) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchLastAddedDevice,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchLastAddedDevice?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchLastAddedDevice(_response);
    });
}

function processSearchLastAddedDevice(response: AxiosResponse): Promise<Types.SameDeviceResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSameDeviceResponseDto(resultData200);
        return Promise.resolve<Types.SameDeviceResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SameDeviceResponseDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigSendWarrantyRequest: Partial<AxiosRequestConfig> | null;
export function getSendWarrantyRequestRequestConfig() {
  return _requestConfigSendWarrantyRequest;
}
export function setSendWarrantyRequestRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendWarrantyRequest = value;
}
export function patchSendWarrantyRequestRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendWarrantyRequest = patch(_requestConfigSendWarrantyRequest ?? {});
}

let _requestConfigGetCertainOrder: Partial<AxiosRequestConfig> | null;
export function getGetCertainOrderRequestConfig() {
  return _requestConfigGetCertainOrder;
}
export function setGetCertainOrderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCertainOrder = value;
}
export function patchGetCertainOrderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCertainOrder = patch(_requestConfigGetCertainOrder ?? {});
}

let _requestConfigPatchOrder: Partial<AxiosRequestConfig> | null;
export function getPatchOrderRequestConfig() {
  return _requestConfigPatchOrder;
}
export function setPatchOrderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchOrder = value;
}
export function patchPatchOrderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchOrder = patch(_requestConfigPatchOrder ?? {});
}

let _requestConfigPatchOrderStatus: Partial<AxiosRequestConfig> | null;
export function getPatchOrderStatusRequestConfig() {
  return _requestConfigPatchOrderStatus;
}
export function setPatchOrderStatusRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchOrderStatus = value;
}
export function patchPatchOrderStatusRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchOrderStatus = patch(_requestConfigPatchOrderStatus ?? {});
}

let _requestConfigClearBasket: Partial<AxiosRequestConfig> | null;
export function getClearBasketRequestConfig() {
  return _requestConfigClearBasket;
}
export function setClearBasketRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigClearBasket = value;
}
export function patchClearBasketRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigClearBasket = patch(_requestConfigClearBasket ?? {});
}

let _requestConfigSearchLastAddedDevice: Partial<AxiosRequestConfig> | null;
export function getSearchLastAddedDeviceRequestConfig() {
  return _requestConfigSearchLastAddedDevice;
}
export function setSearchLastAddedDeviceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchLastAddedDevice = value;
}
export function patchSearchLastAddedDeviceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchLastAddedDevice = patch(_requestConfigSearchLastAddedDevice ?? {});
}